import { statusOptions } from 'bundles/apex/filters/planner_status_filters';
import { clearSelection } from 'bundles/apex/deals/show/store/planner_bulk_actions/actions';

export const SET_STATUSES = 'SET_STATUSES';
export function setStatuses(statusNames, value) {
  return (dispatch) => {
    dispatch(clearSelection());
    dispatch({
      type: SET_STATUSES,
      statusNames,
      value,
    });
  };
}

export function setStatus(statusName, value) {
  return setStatuses([statusName], value);
}

export function setAllStatuses(value) {
  return setStatuses(statusOptions.map(option => option.value), value);
}

export const TOGGLE_ASSIGNEE = 'TOGGLE_ASSIGNEE';
export function toggleAssignee(id) {
  return {
    type: TOGGLE_ASSIGNEE,
    id
  };
}

export const SET_ASSIGNEE = 'SET_ASSIGNEE';
export function setAssignee(id) {
  return (dispatch) => {
    dispatch(clearSelection());
    dispatch({ type: SET_ASSIGNEE, id });
  };
}
